import Vue from 'vue'
import Vuex from 'vuex'
import constdata from '../qrt_misc/const.json';
import config from './constdata.js';

Vue.use(Vuex)

export default new Vuex.Store({
    // sample
    state: {
        user_language: 'en',
        login_user_auth: constdata.STAFF.AUTH.OBSERVER,

        // Project情報
        edit_project_id:'',
        edit_project : '',
        user_join_projects : '',
        
        // PusherLog
        pusher_logs : '',

        // Code情報
        edit_id:'',
        edit_code_id:'',
        edit_code_name:'',
        edit_draft_flag:true,
        edit_activate_flag:true,
    },
    mutations: {

        resetAll(state){
          //  state.login_user.userid =  '';
          //  state.login_user.username = '';
            state.login_user_auth = constdata.STAFF.AUTH.OBSERVER;
            state.user_language = 'en';
            state.edit_project_id = '';
            state.edit_project = '';
            state.user_join_projects = '';

            state.pusher_logs = '';
            
            state.edit_code_id = '';
            state.edit_code_name = '';
            state.edit_draft_flag = true;
            state.edit_activate_flag = true;
        },
        
        resetEdit(state){
            state.edit_code_id = '';
            state.edit_code_name = '';
            state.edit_draft_flag = true;
            state.edit_activate_flag = true;
        },

        resetEditId(state){
            state.edit_id = '';
        },

        resetPusher(state){
            state.pusher_logs = '';
        },

        resetProject(state){
            if(state.edit_project_id != ''){
                // channelがあればclose
                window.Echo.leaveChannel('project.' + state.edit_project_id);        
                //console.log("== channel close == project_id." + state.edit_project_id);
            }
            
            state.edit_project_id = '';
            state.edit_project = '';
            state.user_join_projects = '';
        },

        userLanguage (state, user_language) {
            state.user_language = user_language;
        },
/*         loginUserId (state, login_user_id) {
            state.login_user.userid = login_user_id;
        },
        loginUserName (state, login_user_name) {
            state.login_user.username = login_user_name;
        },
*/
        loginUserAuth (state, login_user_auth) {
            state.login_user_auth = login_user_auth;
        },
        editProjectId (state, edit_project_id) {

            // ↓↓ == 通知のお試し実装 ==
            if (state.edit_project_id != edit_project_id) {
                // 前のプロジェクトのチャネルのリッスン解除
                // window.Echo.leaveChannel('project.' + state.edit_project_id);    // 効かないのでstopListeningに変更
                window.Echo.channel("project_id." + state.edit_project_id)
                .stopListening('MsgToProjMembers');   
                //console.log("== channel close == project_id." + state.edit_project_id);
            }
            if (edit_project_id && state.edit_project_id != edit_project_id) {
                // 変更されたプロジェクトのチャネルのリッスン
                let channel = 'project_id.' + edit_project_id;
                //console.log("== channel open == " + channel);

                window.Echo.channel(channel)
                .listen('MsgToProjMembers', (e) => {
                    //console.log("== MsgToProjMembers recieved ==");
                    //console.log(e);
                    if (e.message != undefined) {
                        //alert(e.message);
                        
                        let pusherObj = [];
                        if(state.pusher_logs != ''){
                          pusherObj = JSON.parse(state.pusher_logs);
                        }
                        if(pusherObj.length >= config.PUSHER_LOG_VIEW_MAX){
                            pusherObj.splice(pusherObj.length, 1); // 最大値より大きい場合は削除
                        }
                        let item = { text: e.message, date: new Date() };
                        pusherObj.splice(0, 0, item);
                    
                        state.pusher_logs = JSON.stringify(pusherObj);
                    }
                });
            }
            // ↑↑ == 通知のお試し実装 ==         

            state.edit_project_id = edit_project_id;
            // ローカルストレージにも保持
            try{
                localStorage.setItem(config.LOCAL_STORAGE_SELECTED_PROJECT_ID, edit_project_id);
            }catch(e){
                console.log(e);
            }


        },
        editProjects (state, edit_project) {
            if(edit_project != state.edit_project){
                state.edit_project = edit_project;
            }
        },
        userJoinProjects (state, user_join_projects) {
            state.user_join_projects = user_join_projects;
        },
        editCodeId (state, edit_code_id) {
            state.edit_code_id = edit_code_id;
        },
        editCodeName (state, edit_code_name) {
            state.edit_code_name = edit_code_name;
        },
        editDraftFlag (state, edit_draft_flag) {
            state.edit_draft_flag = edit_draft_flag;
        },
        editActivateFlag (state, edit_activate_flag) {
            state.edit_activate_flag = edit_activate_flag;
        },
        editId (state, edit_id) {
            state.edit_id = edit_id;
        },
        pusherLog(state, pusher_logs){
            state.pusher_logs = pusher_logs;
        },
    },
});